import config, { version } from "../config";
var DEFAULT_DEBUG_KEYS = [
    "lapel-debugger",
    "lapel-adobe-debugger"
];
var getGlobalLapel = function() {
    return typeof window !== "undefined" ? window["Lapel(v" + version + ")"] : {};
};
var parseDebugValue = function(value) {
    if (typeof value === "string") {
        if (value === "true") {
            return true;
        }
        if (value === "false") {
            return false;
        }
        return value.toLowerCase();
    }
    return value;
};
var getENVDebugLevel = function(debugKeys) {
    if (debugKeys === void 0) debugKeys = DEFAULT_DEBUG_KEYS;
    var _process;
    var env = (_process = process) == null ? void 0 : _process.env;
    if (env) {
        for(var i = 0; i < debugKeys.length; i += 1){
            var envKey = debugKeys[i].toUpperCase().replace(/-/g, "_");
            if (env[envKey]) {
                return parseDebugValue(env[envKey]);
            }
        }
    }
    return null;
};
var getDebugLevel = function(debugKeys) {
    if (debugKeys === void 0) debugKeys = DEFAULT_DEBUG_KEYS;
    try {
        var _window_location, _window;
        if (typeof window === "undefined") {
            // server side
            return getENVDebugLevel(debugKeys);
        }
        var urlParams = new URLSearchParams((_window = window) == null ? void 0 : (_window_location = _window.location) == null ? void 0 : _window_location.search);
        var debugging = null;
        var index = 0;
        while(!debugging && index < debugKeys.length){
            var _urlParams;
            var key = debugKeys[index];
            index += 1;
            var urlValue = (_urlParams = urlParams) == null ? void 0 : _urlParams.get(key);
            if (urlValue) {
                debugging = parseDebugValue(urlValue);
                // Save to sessionStorage to keep value across pages
                sessionStorage.setItem(key, debugging);
            }
            var storageValue = sessionStorage.getItem(key);
            if (storageValue) {
                debugging = parseDebugValue(storageValue);
            }
        }
        return debugging;
    } catch (err) {
        return null;
    }
};
var isDebugging = function(debugKeys) {
    if (debugKeys === void 0) debugKeys = DEFAULT_DEBUG_KEYS;
    return Boolean(getDebugLevel(debugKeys));
};
if (typeof window !== "undefined") {
    if (window.Lapel) {
        console.error("Lapel(v" + window.Lapel.version + ") already defined!");
    }
    window.Lapel = {
        version: version,
        config: config,
        debugLevel: getDebugLevel()
    };
    window["Lapel(v" + version + ")"] = window.Lapel;
}
export { getDebugLevel, isDebugging, getGlobalLapel };

//# sourceMappingURL=debug.js.map